// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2KBGR","content":"styles_content__2IpDT","selectAll":"styles_selectAll__BLXhN"};